<template>

  <div class="single-select" :id="'multiselect-' + uniq">
    <button class="nice-select" type="button" ref="button"
      v-on:click="toggleMenu()">
      {{ visibleValue }}<span>▾</span>
    </button>
  </div>

</template>

<script>
  import overlayModel from "./overlayModel.js"
  import SingleSelectPicker from "./SingleSelectPicker.vue"

  var uniqCounter = 0
  var focusLostListener = null

  export default {
    name: 'single-select',
    props: {
      options: {
        type: Array
      },
      value: {
      },
      display: {
        type: Function,
        default: (x)=>x.title || x
      }
    },
    data () {
      return {
        uniq: "" + (uniqCounter++),
        overlayStackId : null,
        lastCloseTime: 0,
        liveValue: this.value
      }
    },
    computed: {
      visibleValue() {
        return this.display(this.value)
      },
      visibleOptions() {
        let options = this.options.slice()
        return options
      }
    },
    watch: {
      value(q) {
        this.liveValue = q
      }
    },
    methods: {
      set(option) {
        this.liveValue = option
        this.$emit("update:value", this.liveValue)
        if(this.overlayStackId !== null) {
          overlayModel.close(this.overlayStackId)
        }
      },
      toggleMenu() {
        if(this.overlayStackId === null &&  Date.now() - this.lastCloseTime > 230) {
          this.overlayStackId = overlayModel.show({
            component: SingleSelectPicker,
            props: {
              anchor: overlayModel.elementAnchor(this.$refs.button),
              value: this.value,
              options: this.options,
              allOption: this.allOption,
              without: this.without,
              many: this.many,
              display: this.display
            },
            on: {
              'update:value': (value) => this.set(value),
              close: () => {
                this.overlayStackId = null
                this.lastCloseTime = Date.now()
              }
            }
          })
        } else {
          overlayModel.close(this.overlayStackId)
          this.overlayStackId = null
          this.lastCloseTime = Date.now()
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  .nice-select {
    position: relative;
    border: none;
    border-bottom: 1px solid rgba(0,0,0,.12);
    display: block;
    font-size: 16px;
    font-family: "Helvetica","Arial",sans-serif;
    margin: 0;
    padding: 4px 0;
    width: 100%;
    background: 0 0;
    text-align: left;
    color: inherit;
    padding-right: 1.23em
  }

  .nice-select > span {
    display: block;
    position: absolute;
    right: 0;
    top: 10%;
    cursor: default;
  }

  .single-select {
    font-size: 16px;
    display: inline-block;
    box-sizing: border-box;
    width: 300px;
    max-width: 100%;
    margin: 0;
    padding: 10px 0;
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12);
    background: white;
    z-index: 10;
    position: absolute;
    max-height: 50%;
    overflow-y: auto;
  }
  li {
    padding-top: 4px;
    padding-bottom: 4px;
    margin-left: 10px;
    margin-right: 10px;
  }
  li span {
    cursor: pointer;
  }
  li span:nth-child(1) {
    display: inline-block;
    vertical-align: middle;
    width: 100px;
  }

  li:hover {
    color: black;
  }

  ul {
    pointer-events: none;
    max-height: 0px;
    transition: max-height 0.2s;
  }
  ul.visible {
    pointer-events: all;
    max-height: 30vh;
  }

</style>



// WEBPACK FOOTER //
// SingleSelect.vue?84058d20